import { render, staticRenderFns } from "./DecisionBenefitFormDetails.vue?vue&type=template&id=df321d50&"
import script from "./DecisionBenefitFormDetails.vue?vue&type=script&lang=js&"
export * from "./DecisionBenefitFormDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports